import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { Activity } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

import { InMonthBudgetTypes } from '../category/category.store';

export type ActivityModel = getEntityType<ActivityState>;

export type ActivityState = EntityState<
  InMonthBudgetTypes &
    Omit<
      RequireSome<Partial<Activity>, 'category_id' | 'id'>,
      'budget_forecast_settings' | 'total_accrual' | 'total_forecast' | 'total_wp'
    > & {
      discount_flag?: boolean;
      forecast_override_id: null | string;
      primary_settings_id: string;
      secondary_settings_id: string;
      total_cost: number;
      unit_cost: number;
    },
  string
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'activity' })
export class ActivityStore extends EntityStore<ActivityState> {
  constructor() {
    super({});
  }
}
